import request from '@/utils/request'
export const Download = "/workflow/system/sign/user/type/export";

export function queryPage(data) {
  return request({
    url: '/workflow/system/sign/user/type/query_page',
    method: 'post',
    data
  })
}
export function saveOrUpdate(data) {
  return request({
    url: '/workflow/system/sign/user/type/save_or_update',
    method: 'post',
    data
  })
}
export function updateSortNum(data) {
  return request({
    url: '/workflow/system/sign/user/type/update_sort_num',
    method: 'post',
    data
  })
}
export function batchUpdateOrDelete(data) {
  return request({
    url: '/workflow/system/sign/user/type/batch_update_or_delete',
    method: 'post',
    data
  })
}